import React from 'react'
import SEO from "../../common/SEO";
import HeaderOne from '../../common/header/HeaderOne';
import HeaderTopBar from '../../common/header/HeaderTopBar';
import FooterOne from '../../common/footer/FooterOne';
import Copyright from '../../common/footer/Copyright';
import ResetPassword from '../../components/form/ResetPassword';



const ResetPasswordForm = () => {
    return (
        <>
            <SEO title="Password Reset" />
            <main className="page-wrapper">
                <HeaderTopBar />
                <HeaderOne btnStyle="btn-small" HeaderSTyle="header-transparent" />

                {/* This is the Service Categories Area */}
                <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <ResetPassword />
                    </div>
                </div>






                <FooterOne />
                <Copyright />
            </main>

        </>
    )
}

export default ResetPasswordForm
